import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/declaration/declaration-icon.png'
import _imports_1 from '@/assets/images/declaration/declaration-pdf.svg'


const _hoisted_1 = { class: "mainland-declaration" }
const _hoisted_2 = { class: "declaration-card" }
const _hoisted_3 = { class: "declaration-card__body" }
const _hoisted_4 = { class: "declaration-list" }
const _hoisted_5 = { class: "declaration-agree" }

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useMutation } from '@vue/apollo-composable'
import useOpenInfo from '@/hooks/openInfo'
import { RouterName } from '@/enum'
import { openFileView, setApptitle } from '@/utils/native-app'
import * as storage from '@/utils/storage'
import { mutateApi } from '@/graphql/mutation'
import { Message } from '@/components/Message'
import {
  buildInvestorDraftFieldsForDeclaration,
  getDeclarationDraftMeta,
  isRegularOpenAccount
} from '@/utils/investor-draft-fields'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const declarationItems = [
  '所有用以支持投资活动及相关结算的资金均来自内地以外的合法来源。',
  '本人没有因曾使用可疑或伪造文件而令账户遭到任何持牌法团或银行关闭或暂停。',
  '本人承诺，如本《客户声明书》中的资料出现任何更改，会在七个营业日内通知金马证券。',
  '本人确认其明白，金马证券可能会按任何执法机构或监管机构的要求，披露本人的个人及其他相关资料。',
  '本人进一步确认，本人只会使用以本人名义在香港持牌银行或在合资格司法管辖区1受银行业监管机构监督的银行持有的银行账户，作结算之用。 本人并保证，所有与上述账户相关的日后存款及提款，均仅透过该等银行账户进行。'
]

const router = useRouter()
const route = useRoute()
const { title, openType, openInfo, saveOpenInfoOfVuex } = useOpenInfo()

const formType = computed(() => route.query.type || storage.get('formType'))

const prePathName = computed(
  () => (route.query.from as string) || RouterName.ID_TYPE
)

const declarationChecked = ref(false)

const isDisabled = computed(() => !declarationChecked.value)

const buildDeclarationDraftInfo = () => {
  if (!isRegularOpenAccount(formType.value as string)) {
    return { mainlandDeclarationChecked: true }
  }
  const investorFields = buildInvestorDraftFieldsForDeclaration({
    openType: openType.value,
    declarationFrom: route.query.from as string | undefined,
    idKind: openInfo.value?.idKind as number | undefined,
    supplementIdentityType: openInfo.value?.supplementIdentityType as number | undefined
  })
  const content: Record<string, unknown> = {
    mainlandDeclarationChecked: true,
    ...investorFields
  }
  if (route.query.from === RouterName.ID_CARD) {
    if (openInfo.value?.idKind != null) {
      content.idKind = openInfo.value.idKind
    }
    if (openInfo.value?.supplementIdentityType != null) {
      content.supplementIdentityType = openInfo.value.supplementIdentityType
    }
  }
  return content
}

const onCheckedChange = () => {
  saveOpenInfoOfVuex({
    info: { mainlandDeclarationChecked: declarationChecked.value }
  })
}

const { mutate: saveDraft, onDone: saveDraftDone } = useMutation(mutateApi.saveClientFormDraft)

saveDraftDone((res) => {
  const { saveClientFormDraft } = res.data
  if (saveClientFormDraft.ok) {
    saveOpenInfoOfVuex({ info: buildDeclarationDraftInfo() })
    router.push({ name: RouterName.ID_CARD })
  } else {
    Message({ direction: 'vertical', text: '请求异常，请稍后重试！(Draft)' })
  }
})

const handleNext = () => {
  if (isDisabled.value) return
  saveDraft({
    params: {
      formType: formType.value,
      meta: getDeclarationDraftMeta(openType.value),
      content: JSON.stringify(buildDeclarationDraftInfo())
    }
  })
}

const viewDeclarationPdf = () => {
  const fileUrl =
    `${process.env.VUE_APP_H5_STATIC_PAGE_URL}/static_pages/pdf/Client-Declaration-Form.pdf`
  openFileView({
    fileType: 'pdf',
    fileUrl,
    title: '金马客户声明书'
  })
}

onMounted(() => {
  if (!isRegularOpenAccount(formType.value as string)) {
    router.replace({ name: RouterName.ID_CARD })
    return
  }
  setApptitle(title)
  declarationChecked.value = !!openInfo.value?.mainlandDeclarationChecked
})

return (_ctx: any,_cache: any) => {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: handleNext,
    current: 0,
    isDisabled: isDisabled.value,
    prePathName: prePathName.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "declaration-card__head" }, [
            _createElementVNode("div", { class: "declaration-card__head-left" }, [
              _createElementVNode("div", { class: "declaration-card__title-row" }, [
                _createElementVNode("h2", { class: "declaration-card__title" }, "内地客户声明"),
                _createElementVNode("span", { class: "declaration-card__tag" }, "开户必读")
              ]),
              _createElementVNode("div", { class: "declaration-card__intro-wrap" }, [
                _createElementVNode("p", { class: "declaration-card__intro" }, " 本人开立上述金马证券有限公司(「金马证券」) 账户时，特此声明并确认如下 ")
              ])
            ]),
            _createElementVNode("img", {
              class: "declaration-card__icon",
              src: _imports_0,
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(declarationItems, (item, index) => {
                return _createElementVNode("li", {
                  key: index,
                  class: "declaration-list__item"
                }, _toDisplayString(item), 1)
              }), 64))
            ]),
            _createElementVNode("div", {
              class: "declaration-link",
              onClick: viewDeclarationPdf
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                class: "declaration-link__icon",
                src: _imports_1,
                alt: ""
              }, null, -1),
              _createElementVNode("span", { class: "declaration-link__text" }, "查看完整《金马客户声明书》", -1),
              _createElementVNode("i", { class: "iconfont icon-you declaration-link__arrow" }, null, -1)
            ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_field, {
            name: "agree",
            rules: [{ required: true, message: '请您勾选协议' }]
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_checkbox, {
                modelValue: declarationChecked.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((declarationChecked).value = $event)),
                shape: "square",
                onChange: onCheckedChange
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(
                    `iconfont ${
                      declarationChecked.value ? 'icon-duoxuanxuanzhong' : 'icon-duoxuanweixuanzhong'
                    }`
                  )
                  }, null, 2)
                ]),
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, " 本人已经阅读并确认以上 ", -1))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "declaration-agree__hint" }, "未确认声明前，将无法确认下一步", -1))
        ])
      ])
    ]),
    _: 1
  }, 8, ["isDisabled", "prePathName"]))
}
}

})